import React, { useState, useEffect } from 'react';
import {
  IonModal,
  IonButton,
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonIcon
} from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import './ProjectModal.css';

/**
 * ProjectModal Component
 * Modal for creating or editing projects
 */
const ProjectModal = ({ 
  isOpen, 
  onDismiss, 
  onSubmit,
  initialProject = null,
  isSubmitting = false 
}) => {
  const [projectName, setProjectName] = useState('');
  const isEditMode = !!initialProject;

  // Update form when initialProject changes
  useEffect(() => {
    if (initialProject) {
      setProjectName(initialProject.name);
    } else {
      setProjectName('');
    }
  }, [initialProject]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (projectName.trim()) {
      onSubmit({ name: projectName.trim() });
    }
  };

  const handleClose = () => {
    setProjectName('');
    onDismiss();
  };

  return (
    <IonModal 
      isOpen={isOpen} 
      onDidDismiss={handleClose}
      className="project-modal"
    >
      <IonHeader>
        <IonToolbar>
          <IonTitle>{isEditMode ? 'Edit Project' : 'Create Project'}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={handleClose} disabled={isSubmitting}>
              <IonIcon icon={closeOutline} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <form onSubmit={handleSubmit} className="project-modal-form">
          <div className="form-field">
            <label htmlFor="project-name">Project Name</label>
            <input
              id="project-name"
              type="text"
              className="project-input"
              placeholder="Enter project name..."
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
              disabled={isSubmitting}
              autoFocus
            />
          </div>
          
          <div className="modal-actions">
            <IonButton
              fill="clear"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </IonButton>
            <IonButton
              type="submit"
              color="primary"
              disabled={isSubmitting || !projectName.trim()}
            >
              {isSubmitting ? (
                <>
                  <ion-spinner name="crescent"></ion-spinner>
                  {isEditMode ? 'Updating...' : 'Creating...'}
                </>
              ) : (
                <>{isEditMode ? 'Update Project' : 'Create Project'}</>
              )}
            </IonButton>
          </div>
        </form>
      </IonContent>
    </IonModal>
  );
};

export default ProjectModal;



